import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=889584d8&scoped=true&"
import script from "./CopyText.vue?vue&type=script&lang=ts&"
export * from "./CopyText.vue?vue&type=script&lang=ts&"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=889584d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889584d8",
  null
  
)

export default component.exports